/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CourierUserImportFromCsvRequest
 */
export interface CourierUserImportFromCsvRequest {
    /**
     * 
     * @type {string}
     * @memberof CourierUserImportFromCsvRequest
     */
    courierId?: string;
    /**
     * 
     * @type {string}
     * @memberof CourierUserImportFromCsvRequest
     */
    filename?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CourierUserImportFromCsvRequest
     */
    assignMailbox?: boolean;
}

/**
 * Check if a given object implements the CourierUserImportFromCsvRequest interface.
 */
export function instanceOfCourierUserImportFromCsvRequest(value: object): value is CourierUserImportFromCsvRequest {
    return true;
}

export function CourierUserImportFromCsvRequestFromJSON(json: any): CourierUserImportFromCsvRequest {
    return CourierUserImportFromCsvRequestFromJSONTyped(json, false);
}

export function CourierUserImportFromCsvRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourierUserImportFromCsvRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'filename': json['filename'] == null ? undefined : json['filename'],
        'assignMailbox': json['assignMailbox'] == null ? undefined : json['assignMailbox'],
    };
}

export function CourierUserImportFromCsvRequestToJSON(json: any): CourierUserImportFromCsvRequest {
    return CourierUserImportFromCsvRequestToJSONTyped(json, false);
}

export function CourierUserImportFromCsvRequestToJSONTyped(value?: CourierUserImportFromCsvRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'courierId': value['courierId'],
        'filename': value['filename'],
        'assignMailbox': value['assignMailbox'],
    };
}

